import { combineReducers } from "redux";

import { common } from "./common";

export const reducer = combineReducers({
  common
});
